import { __rest } from 'tslib';
import React from 'react';
import { Alert } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekAlert = styled(
//@ts-ignore
(_a) => {
    var { variant = "filled", icon = false, severity = "secondary" } = _a, props = __rest(_a, ["variant", "icon", "severity"]);
    return (React.createElement(Alert, Object.assign({}, props, { variant: variant, icon: icon, severity: severity })));
})(({ theme }) => ({
    "&.MuiPaper-root": {
        alignItems: "center",
    },
    color: theme.palette.text.primary,
    "&.MuiAlert-filledError": {
        backgroundColor: theme.palette.error.light,
    },
    "&.MuiAlert-filledSuccess": {
        backgroundColor: theme.palette.success.light,
    },
    "&.MuiAlert-filledInfo": {
        backgroundColor: theme.palette.primary.light,
    },
    "&.MuiAlert-filledWarning": {
        backgroundColor: theme.palette.warning.light,
    },
    "&.MuiAlert-filledSecondary": {
        //@ts-ignore
        backgroundColor: theme.palette.common.opacityTeal2,
    },
}));

export { PeekAlert, PeekAlert as default };
